// extracted by mini-css-extract-plugin
module.exports = {"footerHeaderColor":"#fff","footerHeaderBackgroundColor":"#23408f"};